export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/~/react-transition-group/esm/config.js
// module id = 846
// module chunks = 118